<p-dropdown [placeholder]="placeholder"
            [options]="options"
            [virtualScroll]="true"
            itemSize="30"
            [readonly]="readonly"
            [filter]="true"
            filterBy="value.details,title,value.title,value.subtitle"
            (onChange)="selectOption($event)">
    >
    <ng-template let-value
                 pTemplate="selectedItem">
        <span class="ui-dropdown-label ui-inputtext ui-corner-all ui-placeholder">{{placeholder}}</span>
    </ng-template>
    <ng-template let-item
                 pTemplate="item">
        <div class="option-container-details" (click)="selectOption(item)">
            <div class="option-inner-container">
                <div class="option-title">{{item.title}}</div>
                <div class="option-subtitle"> {{item.subtitle}} <i class="material-icons">add_circle</i></div>
            </div>
        </div>
    </ng-template>
</p-dropdown>
<al-selectable-list [readonly]="readonly"
                    [options]="value"
                    (onSelectionChanged)="onChangeFn($event)">
</al-selectable-list>